module.exports = __webpack_public_path__ + "static/GoCo.io Inc-059df397db3757c97196f890873355fe.jpg";